<template>
  <fieldset>
    <label
      class="my-2 block font-semibold leading-6 text-gray-900 md:font-bold"
    >
      {{ label }}
    </label>
    <div class="divide-y divide-gray-200">
      <div
        v-for="option in options"
        :key="`${option.value}`"
        class="relative flex items-center py-2.5"
      >
        <div class="flex h-6 items-center">
          <input
            :id="option.value.toString()"
            v-model="sizeStore.selectedSizeOption"
            :value="option"
            type="radio"
            class="h-4 w-4 border-black text-transparent checked:border-2 checked:border-black hover:border-2 hover:border-black checked:hover:border-2 checked:hover:border-black focus:border-2 focus:border-black focus:ring-transparent checked:focus:border-2 checked:focus:border-black active:border-2 active:border-black"
          />
        </div>

        <label
          :for="option.value.toString()"
          class="ml-2 flex w-full cursor-pointer justify-between gap-2 leading-6"
        >
          <span
            class="flex items-center justify-center gap-1.5 md:items-start lg:flex-row"
          >
            <span class="text-gray-900">
              {{ option.label }}
            </span>

            <BadgeLabel
              v-if="
                sizeStore.showMostChosenBadge &&
                option.value.toString() === sizeStore.mostChosenSku
              "
              :label="$t('pages.configurator.sizes.most_chosen')"
              class="shrink-0 self-auto bg-order-buttons/20 text-order-buttons"
            />
          </span>
          <span class="flex items-center justify-between">
            <div class="flex items-center justify-end gap-3">
              <span
                class="text-gray-lighter line-through"
                v-html="option.localizedRecommendedPrice"
              />
              <span class="font-semibold" v-html="option.localizedPrice" />
            </div>
          </span>
        </label>
      </div>

      <div v-if="!!sizeStore.sizeOptions.length" class="py-3">
        <CustomSizeRadioButton
          :custom-size-radio-button-id="customSizeRadioButtonId"
        />
      </div>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import type { SelectorOption } from '@/types/Configurator/SelectorOption';
import { useSizeStore } from '@/stores/Configurator/SizeStore';
import CustomSizeRadioButton from './CustomSizeRadioButton.vue';
import BadgeLabel from '@/components/BadgeLabel.vue';

defineProps({
  label: {
    type: String,
    required: true,
  },

  options: {
    type: Array as PropType<SelectorOption[]>,
    required: true,
  },

  customSizeRadioButtonId: {
    type: String,
    required: false,
    default: 'custom-size-radio-button-desktop',
  },

  isLoading: {
    type: Boolean,
    required: false,
    default: () => false,
  },
});

const sizeStore = useSizeStore();
</script>
